<template>
  <div :style="`background-image: url(${data.bg})`" class="e-memo-jumbotron">
    <h2 v-html="data.title" />
    <slot>
      <b-button
        v-if="hasButton"
        :to="data.btnLink"
        variant="primary"
      >
        {{ data.btnText }}
      </b-button>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'EJumbotronComponent',
    props: {
      data: {
        type: Object,
        default() {
          return {};
        },
      },
      hasButton: {
        type: Boolean,
        default: true,
      },
      functionOnClick: {
        type: [Function, String],
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .e-memo-jumbotron {
    min-height: 300px;
    margin: 0 -15px;
    text-align: right;
    padding: 5rem;
    background: {
      position: center;
      size: cover;
    };

    h2 {
      margin-bottom: 2rem;
      font-size: 3rem;
      color: $white;
    }

    .btn {
      padding: 15px 50px !important
    }
  }

  @include editable-max-width(575px) {
    .e-memo-jumbotron {
      padding: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EJumbotron.vue